import { jsx as _jsx } from "react/jsx-runtime";
import { useController } from 'react-hook-form';
import { GoogleAiProviderForm } from '@modules/ai/common/forms';
import { assignTestId } from '@common/infra/tests/assign-test-id';
import { GeneralProviderFormWrapper } from '../common/general-provider-form-wrapper';
export function GoogleAiConfiguration(props) {
    const { provider, className, form, availableProvider } = props;
    const { fieldState } = useController({ name: `provider.google`, control: form.control });
    return (_jsx(GeneralProviderFormWrapper, { label: "Google Vertex AI", withTestConnection: true, className: className, fieldState: fieldState, ...props, ...assignTestId(provider.id), children: _jsx(GoogleAiProviderForm, { form: form, availableProvider: availableProvider }) }));
}
